import { path } from 'ramda';
import React from 'react';
import { useUserSelector } from 'js/store/hooks';
import { componentService } from 'js/services/component.service';

import style from './UserInfo.scss';

export const UserInfo = ({ userproperty: userProperty = '', property = userProperty }) => {
    const value = useUserSelector(path(['userDetails', ...property.split('.')]));

    return <span className={style.property}>{value}</span>;
};

componentService.registerWebContentComponents({ UserInfo });
